var main = {
    jsToggles: function() {
        var linkToggle = document.querySelectorAll('.js-toggle');

        for(i = 0; i < linkToggle.length; i++) {
        linkToggle[i].addEventListener('click', function(event) {
        
          event.preventDefault();
          
          var container = document.getElementById(this.dataset.container);
        
          if (!container.classList.contains('active')) {
            this.classList.add('is-open');
            container.classList.add('active');
            container.style.height = 'auto';
        
            var height = container.clientHeight + 'px';
        
            container.style.height = '0px';
        
            var parentContainer = container.closest('.sub-parent')
        
        
            setTimeout(function () {
              container.style.height = height;
                if (parentContainer != undefined && parentContainer.clientHeight > 0) {
                  setTimeout( function() {
                    parentContainer.style.height = 'auto';
                    var parentHeight = parentContainer.clientHeight + 'px';
            
                    parentContainer.style.height = '0px';
        
                      parentContainer.style.height = parentHeight;
                  }, 100)
                }
            }, 0);
            
          } else {
            this.classList.remove('is-open');
            
            container.style.height = '0px';
        
            if (container.classList.contains('no-trans')) {
              container.classList.remove('active');
            } else {
              container.addEventListener('transitionend', function () {
                container.classList.remove('active');
              }, {
                once: true
              });
            }
            
            setTimeout(function () {
              var parentContainer = container.closest('.sub-parent')
              var innerSub = container.closest('.inner-sub')
        
              if (innerSub != null) {
                parentContainer.style.height = innerSub.clientHeight + 'px';
              }
            }, 100);
          }
          
        });
        
        }
    }
}

main.jsToggles()